export function downloadCustomCsvCustomer()
{
    return({
        type:"DOWNLOAD_CUSTOM_CSV_CUSTOMER"
    })
}